module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/partners-08-a50a48e29d6c4fcf40911af937ec8624.png";